import { render, staticRenderFns } from "./GestionarAsignados.vue?vue&type=template&id=10aa014a"
import script from "./GestionarAsignados.vue?vue&type=script&lang=js"
export * from "./GestionarAsignados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports